module.exports = __webpack_public_path__ + "static/img/1019_small.0f8d268.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1019_small.png
// module id = 8zN3
// module chunks = 1